//      
import React, {useEffect, useRef, useState} from "react";
                                            
                                                             
import {useTranslation, withTranslation} from "react-i18next";
import "./ProductPage.scss";
import {Swiper, SwiperSlide} from "swiper/react";
import PriceBoxContainer from "../container/PriceBoxContainer";
import ProductSwiperSlide from "./ProductSwiperSlide";
import {useParams} from "react-router";
import Loading from "./Loading";
import {getBtnTextColor} from "../helper/setTextColor";
import {formatContactLocation} from "../helper/contactLocation";
import Zoom from "./Zoom";
                                                        
import {Navigation} from "swiper/modules";
import i18n from "../i18n/i18n";


                         
                 
                                     
                                  
                                    
                                      
                       
               
                       
                    
                   
 

const ProductPage = (props                  ) => {
    const [showImageModal, setImageModal] = useState(false);
    const [modalImage, setModalImage] = useState("");
    const {
        detailedProduct,
        setProductScope,
        images,
        videos
    } = props;
    const {productId} = useParams();

    const {t} = useTranslation();

    const ZoomProps = {
        img: modalImage.attachmentUrl,
        width: 600,
        height: 600,
        zoomScale: 3
    };

    useEffect(() => {
        if (detailedProduct == null || detailedProduct.product.id !== productId) {
            setProductScope(productId);
        }
    }, [productId, detailedProduct, setProductScope]);

    const handleBack = e => {
        e.preventDefault();
        props.goBack(props.filter);
    };

    const showImage = imageUrl => {
        setModalImage(imageUrl);
        toggleImageModal();
    };

    const toggleImageModal = () => {
        setImageModal(!showImageModal);
    };

    const renderContactDetails = contact => {
        if (!contact) {
            return null;
        }
        const contactDetails = [];

        if (contact.recipient) contactDetails.push(<p>{contact.recipient}</p>);
        if (contact.recipientLine2) contactDetails.push(<p>{contact.recipientLine2}</p>);
        if (contact.street) contactDetails.push(<p>{contact.street}</p>);
        if (contact.streetLine2) contactDetails.push(<p>{contact.streetLine2}</p>);
        const location = formatContactLocation(contact);
        if (location) contactDetails.push(<p>{location}</p>);
        if (contact.country) contactDetails.push(<p>{contact.country}</p>);
        if (contact.email) contactDetails.push(<p>{contact.email}</p>);
        if (contact.phone) contactDetails.push(<p>{contact.phone}</p>);
        if (contact.website) contactDetails.push(<p>{contact.website}</p>);

        return contactDetails;
    };

    const hasMultipleGalleryItems = images.length + videos.length > 1;

    const nextGalRef = useRef(null);
    const prevGalRef = useRef(null);
    const nextRefRef = useRef(null);
    const prevRefRef = useRef(null);

    const isTouchDevice = () => {
        return "ontouchstart" in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
    };

    return detailedProduct
        ? <React.Fragment>
	<div className="detail" data-testid={"productDetail"}>
		<div className="control">
			<span><button className="toggle-detail" style={{color: getBtnTextColor()}}
                          data-testid={"backButton"}
                          onClick={e => handleBack(e)}>{props.t("navigation.back")}</button></span>
			<span></span>
		</div>
		<div className="contain">
			<div className="gallery" data-testid={"productGallery"}>
				<div className={"swiper"}>
					<Swiper
                                observer={true}
                                observeParents={true}
                                parallax={true}
                                modules={[Navigation]}
                                className={"swiper-container swiper-gal"}
                                slidesPerView={1}
                                spaceBetween={0}
                                slidesPerGroup={1}
                                autoHeight={false}
                                loopAdditionalSlides={8}
                                allowTouchMove={isTouchDevice()}
                                noSwiping={true}
                                loop={false}
                                grabCursor={false}
                                pagination={{
                                    renderBullet: function (index, className) {
                                        const ariaLabel = t("productDetail.gallery.jumpToImageNumber", {number: index + 1});
                                        return "<button type=\"button\" class=\"" + className + "\" aria-label=\"" + ariaLabel + "\" ></button>";
                                    },
                                    el: ".swiper-pagination",
                                    clickable: true,
                                }}
                                navigation={{
                                    addIcons: false,
                                    nextEl: nextGalRef.current,
                                    prevEl: prevGalRef.current,
                                }}
                                onInit={swiper => {
                                    swiper.params.navigation.nextEl = nextGalRef.current;
                                    swiper.params.navigation.prevEl = prevGalRef.current;
                                    swiper.navigation.init();
                                    swiper.navigation.update();
                                }}
                            >
						{images.map((it, index) =>
							<SwiperSlide className="swiper-slide" key={"image_" + index}>
								<div className="img" aria-label={it.caption}
                                             style={{backgroundImage: `url('${it.attachmentUrl || it.previewImageUrl}')`}}>
									<button aria-label={props.t("navigation.zoom")} className="iconzoom"
                                                    onClick={() => showImage(it)}/>
								</div>
							</SwiperSlide>
                                )}
						{videos.map((video, index) => (
							<SwiperSlide key={"video_" + index}>
								<video controls className="video-slide">
									<source src={video.attachmentUrl} type="video/mp4"/>
									<track kind="captions" srcLang={i18n?.language ?? "de"} src={video.caption} label={i18n?.language ?? "de"}/>
									Your browser does not support the video tag.
								</video>
							</SwiperSlide>
                                ))}
					</Swiper>
					<button
                                ref={nextGalRef}
                                tabIndex={"0"}
                                aria-label={props.t("main.nextSlide")}
                                className={`swiper-button-next swiper-button-next-gal ${!hasMultipleGalleryItems ? "gal-hidden" : ""}`}/>
					<button
                                ref={prevGalRef}
                                tabIndex={"0"}
                                aria-label={props.t("main.prevSlide")}
                                className={`swiper-button-prev swiper-button-prev-gal ${!hasMultipleGalleryItems ? "gal-hidden" : ""}`}/>
					<div
                                className={`swiper-pagination swiper-pagination-gal ${!hasMultipleGalleryItems ? "gal-hidden" : ""}`}/>
					{images.map((it, index) =>
						<style key={"teaser_style_" + index}>
							{`.swiper-pagination-gal .swiper-pagination-bullet:nth-child(${index + 1}) {`}
							{`background-image: url('${it.previewImage ? it.previewImage.attachmentUrl : it.attachmentUrl}') !important;`}
							{"}"}
						</style>
                            )}
					{videos.map((video, index) =>
						<style key={"teaser_style_video_" + index}>
							{`.swiper-pagination-gal .swiper-pagination-bullet:nth-child(${images.length + index + 1}) {`}
							{"opacity: 0.5 !important;"}
							{`background-image: url('${video.previewImage ? video.previewImage.attachmentUrl : video.attachmentUrl}') !important;`}
							{"}"}
							{`.swiper-pagination-gal .swiper-pagination-bullet:nth-child(${images.length + index + 1}):after {`}
							{"content: \"\";"}
							{"}"}
						</style>
                            )}
				</div>
			</div>
			<div className="descript">
				<div className="block">
					<div className="title" data-testid={"detailsTitle"}>
						{props.detailedProduct.product.name}
					</div>
					<PriceBoxContainer/>
					<details className={"description"}>
						<summary>{props.t("productDetail.infoBox.description")}</summary>
						<div dangerouslySetInnerHTML={{__html: props.detailedProduct.product.description}}
                                     data-testid={"detailsDescription"}/>
					</details>
					<details>
						<summary>{props.t("productDetail.infoBox.vehicles")}</summary>
						<div className="carline" data-testid={"detailsModels"}>
							{
                                        props.detailedProduct.product.fitments.length === 0
                                            ? <span>
	{props.t("productDetail.infoBox.empty")}
</span>
                                            : <ul>
	{props.detailedProduct.product.fitments.map(vehicle => <li
                                                    key={vehicle}>{vehicle}</li>)
                                                }
                                            </ul>
                                    }
						</div>
					</details>
					{props.detailedProduct.contacts && (
					<details>
						<summary>{props.t("productDetail.infoBox.contacts")}</summary>
						<div data-testid={"detailsContacts"} className="detailsContacts">
							{props.detailedProduct.contacts.producer && props.detailedProduct.contacts.producer.recipient && (
							<div>
								<strong className={"contact-title"}>
									{props.t("productDetail.contacts.manufacturer-contact")}
								</strong>
								<div className="contact-details">
									<span>{props.t("productDetail.contacts.trademark")}: </span>
									<span>{props.detailedProduct.product.trademark}</span>
									<div className={"trademark"}>
										{renderContactDetails(props.detailedProduct.contacts.producer)}
									</div>
								</div>
							</div>
                                        )}
							{props.detailedProduct.contacts.representative && props.detailedProduct.contacts.representative.recipient && (
							<div>
								<strong className={"contact-title"}>
									{props.t("productDetail.contacts.responsible-contact")}
								</strong>
								<div className="contact-details">
									{renderContactDetails(props.detailedProduct.contacts.representative)}
								</div>
							</div>
                                        )}
						</div>
					</details>
                            )}
				</div>
				<div className="head">
					<span>{props.t("productDetail.relatedArticle")}</span>
					<span></span>
				</div>
				<div className={"swiper"} data-testid={"relatedProducts"}>
					<Swiper
                                observer={true}
                                observeParents={true}
                                parallax={true}
                                modules={[Navigation]}
                                className={"swiper-container swiper-ref"}
                                slidesPerView={1}
                                spaceBetween={5}
                                slidesPerGroup={1}
                                autoHeight={true}
                                loopAdditionalSlides={5}
                                loop={false}
                                allowTouchMove={isTouchDevice()}
                                noSwiping={true}
                                grabCursor={false}
                                navigation={{
                                    addIcons: false,
                                    nextEl: ".swiper-button-next-ref",
                                    prevEl: ".swiper-button-prev-ref",
                                }}
                                onResize={swiper => {
                                    const node = document.querySelector(".swiper-ref > .swiper-wrapper");
                                    if (node) node.style.height = "auto";
                                    swiper.updateAutoHeight();
                                }}
                            >
						{(props.detailedProduct.relatedProducts.map((product, index) =>
							<ProductSwiperSlide product={product} key={"product_" + index}/>
                                ))}
					</Swiper>
					<button
                                ref={nextRefRef}
                                className="swiper-button-next swiper-button-next-ref" tabIndex={"0"}
                                aria-label={props.t("main.nextSlide")}/>
					<button
                                ref={prevRefRef}
                                className="swiper-button-prev swiper-button-prev-ref"
                                tabIndex={"0"}
                                aria-label={props.t("main.prevSlide")}/>
				</div>
				<div className={"swiper"}>
					{props.detailedProduct.relatedProducts.map(product =>
						<div key={product.id}/>
                            )}
				</div>
			</div>
			{
                        showImageModal &&
                        <div className="zoom">
	<Zoom {...ZoomProps}/>
	<button
                                className="iconclose" aria-label={"navigation.close"}
                                onClick={() => toggleImageModal()}/>
                        </div>
                    }
		</div>
	</div>
	<footer>
		<span>{props.disclaimer}</span>
	</footer>
        </React.Fragment>
        : <Loading/>;
};

export default withTranslation()(ProductPage);
